import { fetchRequestWithTypes } from './index.js';

export const GET_BILLING_FREQUENCY_REQUEST = 'GET_BILLING_FREQUENCY_REQUEST';
export const GET_BILLING_FREQUENCY_SUCCESS = 'GET_BILLING_FREQUENCY_SUCCESS';
export const GET_BILLING_FREQUENCY_ERRORED = 'GET_BILLING_FREQUENCY_ERRORED';

export const getBillingFrequency = () =>
	fetchRequestWithTypes({
		types: [
			GET_BILLING_FREQUENCY_REQUEST,
			GET_BILLING_FREQUENCY_SUCCESS,
			GET_BILLING_FREQUENCY_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/users/:uuid/subscriptions/billingFrequencies`,
		},
	});

export const PUT_BILLING_FREQUENCY_REQUEST = 'PUT_BILLING_FREQUENCY_REQUEST';
export const PUT_BILLING_FREQUENCY_SUCCESS = 'PUT_BILLING_FREQUENCY_SUCCESS';
export const PUT_BILLING_FREQUENCY_ERRORED = 'PUT_BILLING_FREQUENCY_ERRORED';

export const putBillingFrequency = (frequency: string) =>
	fetchRequestWithTypes({
		types: [
			PUT_BILLING_FREQUENCY_REQUEST,
			PUT_BILLING_FREQUENCY_SUCCESS,
			PUT_BILLING_FREQUENCY_ERRORED,
		],
		request: {
			method: 'PUT',
			path: `/apis/customers/v1/users/:uuid/subscriptions/billingFrequencies`,
			body: {
				frequency,
			},
		},
	});
